import { connect } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import BatchNote from '../../../../../components/batches/batch-note/';

const autoGeneratedBackendNote = 'CreateAndProcessBatchByOrderIds';

const mapStateToProps = (state, ownProps) => {
  const { batchId } = ownProps;
  const batches = Global.selectBatchesLabelBatchStatusModalLabelBatchStatusModalBatches(state);
  const batch = batches.find((b) => b.batchId === batchId) || {};
  const note = batch.batchNotes;
  return {
    batchId: batch.batchId,
    note: note === autoGeneratedBackendNote ? undefined : note,
    name: batch.name || batch.batchNumber,
    assignedToGuid: batch.userId,
  };
};

export const BatchNoteContainer = connect(mapStateToProps, null)(BatchNote);
